// =============================================================================
// src/rules/board-lookup.js  —  shared board lookups (Get, GetPosition)
// -----------------------------------------------------------------------------
// SHARED RULES (client + server) — see src/rules/random.js for how these files
// are used and bundled. Self-contained: no imports, no cross-file calls.
//
// The board is duel.board[y][x] (4x4). Rows 0–1 are the opponent's side, rows
// 2–3 the active player's. Spot codes: "Card_<i>" (hand) / "Board_<y>_<x>".
// =============================================================================

/**
 * Find where a card object sits on the board.
 * @param {object} duel
 * @param {object} card
 * @returns {{y:number,x:number,item:object}|null}
 */
export function GetPosition(duel, card) {
	for (let y = 0; y < duel.board.length; y++) {
		for (let x = 0; x < duel.board[y].length; x++) {
			const item = duel.board[y][x];
			if (!item) {
				continue;
			}
			if (card == item) {
				return { y, x, item };
			}
		}
	}
	return null;
}

/**
 * Resolve a spot code to the card object it points at.
 * @param {object} duel
 * @param {string} Entry  "Card_<i>" or "Board_<y>_<x>".
 * @returns {object|false}
 */
export function Get(duel, Entry) {
	try {
		if (Entry.includes("Card")) {
			return duel.player1.hand[Number(Entry.split("_")[1])];
		} else if (Entry.includes("Board")) {
			return duel.board[Number(Entry.split("_")[1])][Number(Entry.split("_")[2])];
		} else {
			return false;
		}
	} catch (error) {
		console.error(`Error processing ${Entry}. Error: ${error.message}`);
		console.error(`Stack trace: ${error.stack}`);
	}
}
